import React from 'react';
import { 
  AlertTriangle, 
  Info, 
  Clock,
  Shield,
  ExternalLink 
} from 'lucide-react';

const Disclaimer = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-gray-100 pt-24">
      {/* Minimal Header */}
      <header className="bg-white border-b border-gray-100 shadow-sm">
        <div className="max-w-4xl mx-auto px-4 py-6">
          <div className="flex items-center space-x-3">
            <AlertTriangle className="w-6 h-6 text-amber-500" />
            <h1 className="text-2xl font-semibold text-gray-800">Disclaimer</h1>
          </div>
        </div>
      </header>

      {/* Rest of the component remains the same */}
      <main className="max-w-4xl mx-auto px-4 py-12">
        {/* Last Updated Notice */}
        <div className="flex items-center text-sm text-gray-500 mb-8">
          <Clock className="w-4 h-4 mr-2" />
          Last updated: January 21, 2025
        </div>

        {/* Main Content Card */}
        <div className="bg-white rounded-2xl shadow-sm p-8 mb-8">
          <div className="prose max-w-none">
            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-800 mb-4">General Disclaimer</h2>
              <p className="text-gray-600 leading-relaxed">
                The information provided by Gortherm ("Company", "we", "our", "us") on our website 
                and services is for general informational purposes only. All information is provided 
                in good faith, however we make no representation or warranty of any kind, express or 
                implied, regarding the accuracy, adequacy, validity, reliability, availability, or 
                completeness of any information.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-800 mb-4">No Liability</h2>
              <p className="text-gray-600 leading-relaxed">
                Under no circumstance shall we have any liability to you for any loss or damage of 
                any kind incurred as a result of the use of our services or reliance on any 
                information provided. Your use of our services and your reliance on any information 
                is solely at your own risk.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-800 mb-4">External Links</h2>
              <p className="text-gray-600 leading-relaxed">
                Our service may contain links to external websites that are not provided or 
                maintained by us. We do not guarantee the accuracy, relevance, timeliness, or 
                completeness of any information on these external websites.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-800 mb-4">Professional Advice</h2>
              <p className="text-gray-600 leading-relaxed">
                The information is not intended as professional advice. Before taking any actions 
                based upon such information, we encourage you to consult with the appropriate 
                professionals. We do not provide any kind of professional advice.
              </p>
            </section>
          </div>
        </div>

        {/* Important Notice Box */}
        <div className="bg-amber-50 border border-amber-100 rounded-xl p-6 mb-8">
          <div className="flex items-start">
            <Info className="w-5 h-5 text-amber-500 mt-1 mr-4 flex-shrink-0" />
            <p className="text-sm text-amber-700">
              By using our services, you hereby consent to our disclaimer and agree to its terms. 
              If you require any more information or have any questions about our disclaimer, please 
              feel free to contact us.
            </p>
          </div>
        </div>

        {/* Simple Contact Section */}
        
      </main>

      {/* Minimal Footer */}
      
    </div>
  );
};

export default Disclaimer;